import React, { createContext, useState, useContext, useEffect } from 'react';
import enTranslations from '../translations/en.json';
import huTranslations from '../translations/hu.json';

const LanguageContext = createContext();

const translations = {
  en: enTranslations,
  hu: huTranslations,
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  // Default to Hungarian ('hu')
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('wedding-language');
    return savedLanguage || 'hu';
  });

  useEffect(() => {
    localStorage.setItem('wedding-language', language);
  }, [language]);

  const changeLanguage = (lang) => {
    setLanguage(lang);
  };

  // Translation function that accepts dot notation keys (e.g., "nav.home")
  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        return key; // Return key if translation not found
      }
    }
    
    return value || key;
  };

  const value = {
    language,
    changeLanguage,
    t,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

